/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `LinkTarget*`'s.
 */
export type LinkTarget = LinkTargetBlank | LinkTargetSelf;

/**
 * The Link blank target type.
 */
export type LinkTargetBlank = typeof LINK_TARGET_BLANK;

/**
 * The Link self target type.
 */
export type LinkTargetSelf = typeof LINK_TARGET_SELF;

/**
 * The Link blank target constant.
 */
export const LINK_TARGET_BLANK = `_blank`;

/**
 * The Link self target constant.
 */
export const LINK_TARGET_SELF = `_self`;
